import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// On native, "Replace a step" pushes its picker as another screen in the
// check's modal. The check remembers its own URL when it opens the picker, the
// picker hands its pick back and returns to that URL (which the native
// navigators treat as going back), and the check then rechecks with the pick.
const KEY = "routine-placement-replace-pick"

export default class extends Controller {
  connect() {
    const stored = read()
    if (!stored?.url || stored.returnUrl !== location.href) return

    sessionStorage.removeItem(KEY)
    // Alpine sets up its listeners after Stimulus connects.
    setTimeout(() => this.dispatch("picked", { detail: { url: stored.url } }))
  }

  open() {
    write({ returnUrl: location.href })
  }

  // A picker opened on its own has nowhere to return to, so it rechecks in
  // place as it does on the web.
  choose(event) {
    const returnUrl = read()?.returnUrl
    if (!returnUrl) return

    const url = new URL(this.element.action, location.href)
    for (const [name, value] of new FormData(this.element)) url.searchParams.append(name, value)
    if (!write({ returnUrl, url: `${url.pathname}${url.search}` })) return

    event.preventDefault()
    Turbo.visit(returnUrl)
  }
}

function read() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY))
  } catch {
    return null
  }
}

function write(value) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(value))
    return true
  } catch {
    return false
  }
}
